
export function maybePlural(count, noun) {
  return count + ' ' + (count === 1 ? noun : noun + 's');
}

export function formatCurrency(amount, fractionDigits=2) {
  return amount.toLocaleString(
    undefined,
    {
      minimumFractionDigits: fractionDigits,
      maximumFractionDigits: fractionDigits
    }
  )
}
